var shortWeekDayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var mediumWeekDayNames = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
var longWeekDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var longMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var shortMonthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
var pickerDayList = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
var data = {
    locale: 'en',
    otherLocale: 'nl',
    otherLocaleLong: 'Nederlands',
    pick: (function (choices) { return choices['en'] || choices['nl'] || choices[Object.keys(choices)[0]]; }),
    pickWithLocale: (function (choices, locale) { return choices[locale] || choices[Object.keys(choices)[0]]; }),
    shortWeekDayNames: shortWeekDayNames,
    mediumWeekDayNames: mediumWeekDayNames,
    longWeekDayNames: longWeekDayNames,
    longMonthNames: longMonthNames,
    shortMonthNames: shortMonthNames,
    pickerDayList: pickerDayList,
    formatShortMonthNames: function (d) { return "" + shortMonthNames[d.getMonth()]; },
    formatMediumDayName: function (d) { return "" + mediumWeekDayNames[d.getDay()]; },
    formatShortDay: function (d) { return mediumWeekDayNames[d.getDay()] + " " + d.getDate(); },
    formatMediumDate: function (d) { return mediumWeekDayNames[d.getDay()] + " " + d.getDate() + " " + shortMonthNames[d.getMonth()] + " " + d.getFullYear(); },
    formatLongDate: function (d) { return longWeekDayNames[d.getDay()] + " " + d.getDate() + " " + longMonthNames[d.getMonth()]; },
    formatNumericalYearMonthDate: function (d) { return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate(); },
    formatLongMonthYear: function (d) { return longMonthNames[d.getMonth()] + " " + d.getFullYear(); },
    formatLongDayName: function (d) { return "" + longWeekDayNames[d.getDay()]; },
    formatDateRange: function (d1, d2) { return ((d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) ?
        mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()
        : (d1.getFullYear() === d2.getFullYear()) ?
            mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " " + shortMonthNames[d1.getMonth()] + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()
            :
                mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " " + shortMonthNames[d1.getMonth()] + " " + d1.getFullYear() + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()); },
    // formatTime: (d) => `${(d.getHours()) % 12}:${d.getMinutes().toString().length < 2 ? d.getMinutes().toString() + '0' : d.getMinutes().toString()} ${d.getHours() >= 12 ? 'PM' : 'AM'}`,
    formatTime: function (d) { return d.getHours() + ":" + (d.getMinutes().toString().length < 2 ? '0' + d.getMinutes().toString() : d.getMinutes().toString()); },
    authHome: 'Home',
    authLinksSignIn: 'Log in',
    authLinksForgotPassword: 'Forgot your password?',
    authAlreadyHaveAccount: 'Do you have an account?',
    authCreateCompany: 'Create a New Company',
    authAlreadyCompany: 'Company already exist?',
    authAlreadyCompanyJoin: 'Join to my company with a code.',
    authAlreadyCompanyEnterCode: 'Enter the invitation code received by email or SMS.',
    authLogin: 'Log in',
    authDownloadApp: 'Please login with the mobile application or download it from the App Store or Google Play.',
    authExistingAccountTitle: 'Existing User',
    authExistingAccount: 'There is already an account associated with this email or mobile phone number.',
    authYouWillJoin: 'You will be joining',
    authJoin: 'Join',
    authSignYouIn: 'Sign in.',
    authNewOn: 'Are you new to WondAdviseur?',
    authWelcomeToGivo: 'Welcome to WondAdviseur',
    authOr: 'or',
    authRegister: 'Create an account',
    authDiscover: 'Discover WondAdviseur',
    authLoginWithFacebook: 'Login with Facebook',
    authRegisterWithFacebook: 'Register with Facebook',
    inputTitlePlaceholder: 'Title',
    inputSubtitlePlaceholder: 'Subtitle',
    inputTitleIndication: 'Indications',
    inputTitleColor: 'Color',
    inputTitleType: 'Type',
    inputTitleIcon: 'Logo',
    inputUploaderPlaceholder: 'Drag or click to upload a file',
    inputTitleContent: 'Content',
    inputChoose: 'Choose',
    inputInstructionsTitle: 'Instructions',
    inputDescriptionTitle: 'Description',
    inputFeaturesTitle: 'Features',
    inputIndicationsTitle: 'Indications',
    inputOrderInfoTitle: 'Order info',
    inputTitleProtocol: 'Protocol',
    inputDeeplink: 'Deeplink',
    inputTitleIntroduction: 'Inrtoductie',
    inputTitleAttachedProducts: 'Linked products',
    inputTitleAttachedWounds: 'Linked wounds',
    inputTitlePhoto: 'Photo',
    inputGroup: 'Group',
    inputOptional: '(Optional)',
    inputTitleFormats: 'Formats',
    inputProductCombinations: 'Linked product combinations',
    inputAddCombination: 'Add combination',
    avatarAlt: 'Avatar',
    avatarTitle: function (name) { return name; },
    alertModalTitle: 'Alert',
    alertModalOk: 'Ok',
    alertModalConfirm: 'Confirm',
    alertModalCancel: 'Cancel',
    alertModalApply: 'Apply on',
    alertModalShowLess: 'Show less',
    validationEmailError: 'Please enter your email address.',
    validationEmailValidError: 'Please enter a valid email address',
    validationPhoneValidError: 'Please enter a valid phone number',
    validationPasswordError: 'Please enter your password.',
    validationCodeError: 'Please enter the validation code you received via email or SMS.',
    validationPasswordLengthError: 'Your new password must be at least 6 characters.',
    validationPasswordConfirmError: 'Your password confirmation doesn\'t match.',
    validationFirstNameError: 'Please enter your first name.',
    validationLastNameError: 'Please enter your last name.',
    validationCompanyNameError: 'Please enter the name of your company.',
    validationPositionNameError: 'You must enter a name for this position.',
    validationLocationNameError: 'Please enter the name.',
    validationLocationStreetError: 'Please enter the street.',
    validationLocationCityError: 'Please enter the city.',
    validationSelectLocaitonError: 'Please select an address from your search result to add new location.',
    validationTeamListError: 'Please select at least one team from the list above.',
    validationTeamNameError: 'Please enter a name for this team.',
    validationCompanyCode: 'The invitation code must be 6 characters long.',
    validationEventRecurrence: 'The renewal date must be later than the current expiration date.',
    validationHourlyWageError: 'Hourly wage must be valid.',
    validationMaxHoursError: 'Max. weekly hours must be valid.',
    validationIndustryType: 'Please enter the type of your industry.',
    validationCompanyType: 'Please select the type of the industry.',
    validationCodeInvalid: 'The validation code is expired or invalid. Please request a new code.',
    validationTitleError: 'Please enter the title.',
    validationContentError: 'Please enter the content.',
    validationAboutError: 'Please enter the about text',
    validationAddressError: 'Please enter the address',
    validationLatitudeError: 'Please enter the latitude',
    validationLongitudeError: 'Please enter the longitude',
    validationOpeningsError: 'Please enter the availability',
    validationIndicationError: 'Please enter the indication',
    validationImageError: 'Please attach an image',
    validationSelectError: 'Please select an item from the list',
    validationInstructionError: 'Please enter the instructions',
    validationDescriptionError: 'Pleae enter the description',
    validationFeaturesError: 'Please enter the properties',
    validationIndicationsError: 'Please enter the indications',
    validationOrderInfoError: 'Please enter the order info',
    validationProtocolError: 'Please enter the protocol',
    validationFeaturedError: 'Please select an item',
    validationFormatError: 'Please add a format',
    validationWoundTypeError: 'Please select a wound type',
    headerBarLogOut: 'Log Out',
    sideBarWelcome: 'Welcome,',
    sideBarProfile: 'My profile',
    sideBarHome: 'Home',
    sideBarSettings: 'Settings',
    sideBarHelp: 'Help',
    sideBarCopyright: "\u00A9 WondAdviseur, " + new Date().getFullYear(),
    sideBarAdmins: 'Admins',
    sideBarProducts: 'Products',
    sideBarProductsGuide: 'Products guide',
    sideBarPushNotifications: 'Push Notifications',
    sideBarWounds: 'Sub wound type',
    sideBarMedias: 'Media',
    sideBarModels: 'WCS Model',
    sideBarVision: 'Our vision',
    sideBarReferences: 'References',
    sideBarExtras: 'Extras',
    sideBarHygienes: 'WH Model',
    loginViewEmailPlaceholder: 'Email Address',
    loginViewPasswordPlaceholder: 'Password',
    loginViewRememberMe: 'Remember me?',
    loginViewSignIn: 'Log in',
    loginViewNewUser: 'New User',
    loginViewEmployeeAlert: 'This console panel is only available for managers.',
    loginByContinuingYouAccept: 'By creating your account, your accept ',
    loginViewTermsAndConditions: 'WondAdviseur\'s Terms & Conditions.',
    loginErrorLogin: 'This email and password combination do not match any existing account.',
    loginErrorLocked: 'The account has been locked try again in 10 minutes.',
    loginLogoutMember: 'Back to Login',
    homeTitle: 'Home',
    homePhone: 'Phone',
    homeAbout: 'About',
    homeAddress: 'Address',
    homeLongitude: 'Longitude',
    homeLatitude: 'Latitude',
    homeOpenings: 'Availability time',
    homeVision: 'Our vision',
    homeFeatured: 'Featured products',
    actionYes: 'Yes',
    actionNo: 'No',
    actionDelete: 'Delete',
    actionCreate: 'Create',
    actionUpdate: 'Update',
    actionSend: 'Send',
    actionRefresh: 'Refresh',
    settingsTitle: 'Settings',
    settingsEdit: 'Edit',
    settingsSave: 'Save',
    settingsOptional: 'optional',
    homeSearch: 'Search',
    homeSearchFor: function (type) { return "Enter the name of the " + type; },
    homeSearchForOffer: 'Find an offer',
    homeSearchLocation: 'Select location',
    homeLatestOffers: 'Latest offers',
    homeFooterRights: 'WondAdviseur.nl - All righrs reserved',
    homeInitiative: 'Initiatief van',
    homeSupport: 'Ondersteund door',
    adminsTitle: 'Admins',
    adminsDeleteUserSummary: 'Are you sure you want to delete this admin?',
    adminsEmail: 'Email',
    adminsFirstName: 'First name',
    adminsLastName: 'Last name',
    adminsFirstNamePlaceholder: 'First name (optional)',
    adminsLastNamePlaceholder: 'Last name (optional)',
    adminsAction: 'Action',
    adminsCreateTitle: 'Create new admin',
    customersTitle: 'Customers',
    pushNotificationsTitle: 'Push Notifications',
    pushNotificationsSendTitle: 'Send push notification',
    pushNotificationsConfirm: 'Are you sure you want to send this message to all the users?',
    pushNotificationsFormTitle: 'Title',
    pushNotificationsFormContent: 'Content',
    productsTitle: 'Products',
    productsItemTitle: 'Title',
    productsSubtitle: 'Subtitle',
    productsAction: 'Action',
    productsCreateTitle: 'Create new product',
    productsUpdateTitle: 'Update product',
    productsGroupCreateTitle: 'Create new group',
    productsGroupUpdateTitle: 'Update group',
    productsDeleteSummary: 'Are you sure you want to deleted this product?',
    productsDeleteGroupSummary: 'Are you sure you want to deleted this product group?',
    productsGroupTitle: 'Product Groups',
    productsFormatFormat: 'Format',
    productsFormatAmount: 'Amount',
    productsFormatOrder: 'Order Nbr.',
    productsFormatIndex: 'zIndex Nbr.',
    woundsTitle: 'Wound types',
    woundsItemTitle: 'Title',
    woundsSubtitle: 'Subtitle',
    woundsAction: 'Action',
    woundsCreateTitle: 'Create new wound type',
    woundsUpdateTitle: 'Update wound type',
    woundsDeleteSummary: 'Are you sure you want to deleted this wound type?',
    woundsItemImage: 'Image',
    woundsSubTitle: 'Sub wound types',
    woundsSubCreateTitle: 'Create new sub wound type',
    woundsSubUpdateTitle: 'Update sub wound type',
    woundsSubDeleteSummary: 'Are you sure you want to deleted this sub wound type?',
    mediasTitle: 'Media',
    mediasAction: 'Action',
    mediasDeleteSummary: 'Are you sure you want to deleted this image?',
    mediasItemImage: 'Image',
    mediasItemUrl: 'Url',
    modelsTitle: 'WCS Model',
    modelsItemTitle: 'Title',
    modelsSubtitle: 'Subtitle',
    modelsAction: 'Action',
    modelsCreateTitle: 'Create new model',
    modelsUpdateTitle: 'Update model',
    modelsDeleteSummary: 'Are you sure you want to deleted this model?',
    modelsIfInfected: 'If infected',
    hygienesTitle: 'WH Model',
    hygienesItemTitle: 'Title',
    hygienesSubtitle: 'Subtitle',
    hygienesAction: 'Action',
    hygienesCreateTitle: 'Create new model',
    hygienesUpdateTitle: 'Update model',
    hygienesDeleteSummary: 'Are you sure you want to deleted this model?',
    hygienesIfInfected: 'If infected',
    black: 'Black',
    yellow: 'Yellow',
    red: 'Red',
    infected: 'Infected',
    dry: 'Dry',
    damp: 'Damp',
    wet: 'Wet',
    extrasCreateTitle: 'Create new item',
    extrasUpdateTitle: 'Update item',
    extrasDeleteSummary: 'Are you sure you want to delete this item?',
};
export default data;
